import React, { useState, useEffect } from "react";
import { getToken } from "../../Utils/Common";
import axios from "axios";
import { Link } from "react-router-dom";
import ReactStars from "react-rating-stars-component";

function Library() {
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);
  const [sucessMessage, setsucessMessage] = useState("");
  const [error, setError] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const token = getToken();

  useEffect(() => {
    const axiosOptions = {
      url: process.env.REACT_APP_API_URL + `v1/user/book-list`,
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(axiosOptions)
      .then((response) => {
        console.log(response.data.data.data);
        setData(response.data.data.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        // console.log(err.response.data.message);
        if (err.response.status === 404) {
          setErrorMessage(err.response.data.message);
        } else if (err.response.status === 401) {
          // console.log(err.response.data.message);
        }
      });
  }, []);

  // console.log(data);

  const averageRating = {
    size: 25,
    value: "3",
    count: 5,
    isHalf: true,
    value: 3,
    color: "gray",
    activeColor: "#000",
    edit: false,
  };

  console.log(data.overall_star);
  return (
    <div className="card mb-5 mb-xl-8 p-9" style={{ marginTop: "65px" }}>
      <div className="container-xxl" id="kt_content_container">
        <div className="d-flex justify-content-center">
          <div
            className={loader === true ? "spinner-border" : ""}
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <div style={{ textAlign: "center", fontSize: "50px" }}>
          My Library
          <hr style={{ color: "rgb(171 166 166)", height: "3px" }} />
        </div>
        <div className="card-body p-0">
          {data.length > 0 ? (
            data.map((data, index) => (
              <div key={index}>
                <div className="row p-8">
                  <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <img
                      alt="Pic"
                      src={data.image_path}
                      className="img-fluid"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-lg-5 col-xl-7">
                    <div className="row">
                      <div
                        className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                        style={{ fontSize: "35px" }}
                      >
                        {data.title}
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: "20px" }}>
                      <div
                        className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                        style={{ fontSize: "20px" }}
                      >
                        {data.description}
                      </div>
                    </div>
                    <div
                      className="row"
                      style={{ fontSize: "10px", marginTop: "25px" }}
                    >
                      <div
                        className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                        style={{ fontSize: "25px" }}
                      >
                        <span>Difficulty:</span>{" "}
                        <span
                          className={
                            data.difficulty === "Easy"
                              ? "border-active-light"
                              : ""
                          }
                        >
                          Easy
                        </span>
                        /{" "}
                        <span
                          className={
                            data.difficulty === "Medium"
                              ? "border-active-light"
                              : ""
                          }
                        >
                          Medium
                        </span>{" "}
                        /{" "}
                        <span
                          className={
                            data.difficulty === "Hard"
                              ? "border-active-light"
                              : ""
                          }
                        >
                          Hard
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-4 col-md-2 col-lg-3 col-xl-3">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <Link
                          className="btn btn-dark mb-1 w-250px"
                          to={`/library/${data.book_code}/read`}
                        >
                          Read
                        </Link>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fs-3">
                        <span>Difficulty:</span>
                        <span
                          className={
                            data.difficulty === "Easy"
                              ? "border-active-light ms-1"
                              : "ms-1"
                          }
                        >
                          Easy
                        </span>
                        /
                        <span
                          className={
                            data.difficulty === "Medium"
                              ? "border-active-light ms-1"
                              : "ms-1"
                          }
                        >
                          Medium
                        </span>
                        /
                        <span
                          className={
                            data.difficulty === "Hard"
                              ? "border-active-light ms-1"
                              : "ms-1"
                          }
                        >
                          Hard
                        </span>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-12">
                        {data.sample_audio !== undefined ? (
                          <audio controls>
                            <source src={data.sample_audio} type="audio/ogg" />
                            <source src={data.sample_audio} type="audio/mpeg" />
                          </audio>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6 fw-bold text-muted fs-4">
                        <span>Global:</span>
                      </div>

                      <div className="col-6 mt-n2">
                        <ReactStars
                          size={24}
                          value={data.overall_star}
                          count={5}
                          isHalf={true}
                          edit={false}
                          activeColor={"#000"}
                        />
                      </div>

                      <div className="col-6 fw-bold text-muted fs-4">
                        <span>Performance:</span>
                      </div>

                      <div className="col-6 mt-n2">
                        <ReactStars
                          size={24}
                          value={data.performance_star}
                          count={5}
                          isHalf={true}
                          edit={false}
                          activeColor={"#000"}
                        />
                      </div>

                      <div className="col-6 fw-bold text-muted fs-4">
                        <span>Histoire:</span>
                      </div>
                      <div className="col-6 mt-n2">
                        <ReactStars
                          size={24}
                          value={data.story_star}
                          count={5}
                          isHalf={true}
                          edit={false}
                          activeColor={"#000"}
                        />
                      </div>
                    </div>
                    {/* })} */}

                    <div className="row">
                      <div className="col-12 mt-15 fs-2hx fw-bolder">
                        <Link
                          to={`/library/${data.book_code}/write-a-review`}
                          className="text-dark"
                        >
                          Write a Review
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="">
                  <hr style={{ color: "rgb(171 166 166)", height: "3px" }} />
                </div>
              </div>
            ))
          ) : (
            <div
              style={{ textAlign: "center", color: "red", fontSize: "20px" }}
              className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            >
              {errorMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Library;
